import { PageTemplate } from '@streamamg/components-lib';


export const configsPageTemplate: PageTemplate = {
  home: {
    template: 'home',
    wpPage: 'home',
  },
  archive: {
    template: 'archive',
    wpPage: 'archive',
  },
  calendar: {
    template: 'calendar',
    wpPage: 'calendar',
  },
  packages: {
    template: 'packages',
    wpPage: 'packages',
  },
  team: {
    template: 'team',
    nParams: 1,  // team slug
  },
  vod_player: {
    template: 'vod-player',
    wpPage: 'video-player',
    nParams: 1, // vod title
  },
  live_player: {
    template: 'live-player',
    wpPage: 'video-player',
    nParams: 1, // match title
  },
  // live_multicam: {
  //   template: 'live-multicam',
  //   wpPage: 'video-player',
  // },
  cloud_pay: {
    template: 'cloud-pay',
  },
  register: {
    template: 'cloud-pay',
    wpPage: 'register',
  },
  my_account: {
    template: 'cloud-pay',
  },
  forgot_password: {
    template: 'cloud-pay',
  },
  purchase: {
    template: 'purchase',
    wpPage: 'purchase',
    nParams: 1, // package
  },
  documentaries: {
    template: 'documentaries',
    wpPage: 'documentaries',
    nParams: 1, // package
  },
};

